/* eslint-disable no-undef */
import React, { createContext, useRef, useState } from 'react';

export type MapListingViews = 'map' | 'list';
export type ViewTriggerButtonPositions = 'sticky' | 'absolute';

interface MapListingContextProps {
  activeView: MapListingViews;
  setActiveView: React.Dispatch<React.SetStateAction<MapListingViews>>;
  stickyViewTogglePosition: ViewTriggerButtonPositions;
  setStickyViewTogglePosition: React.Dispatch<React.SetStateAction<ViewTriggerButtonPositions>>;
  stickyViewToggleVisibility: boolean;
  setStickyViewToggleVisibility: React.Dispatch<React.SetStateAction<boolean>>;
  stickyViewContainerRef: React.RefObject<HTMLDivElement>;
  stickyViewToggleRef: React.RefObject<HTMLDivElement>;
}
export const MapListingContext = createContext({} as MapListingContextProps);
MapListingContext.displayName = 'MapListingContext';

export const MapListingContextProvider = ({
  children,
  defaultActiveView = 'list',
}: {
  children: any;
  defaultActiveView?: MapListingViews;
}) => {
  const [activeView, setActiveView] = useState<MapListingViews>(defaultActiveView);
  const [stickyViewTogglePosition, setStickyViewTogglePosition] = useState<ViewTriggerButtonPositions>('sticky');
  const [stickyViewToggleVisibility, setStickyViewToggleVisibility] = useState<boolean>(true);
  const stickyViewContainerRef = useRef<HTMLDivElement>(null);
  const stickyViewToggleRef = useRef<HTMLDivElement>(null);

  const contextValues: MapListingContextProps = {
    activeView,
    setActiveView,
    stickyViewTogglePosition,
    setStickyViewTogglePosition,
    stickyViewToggleVisibility,
    setStickyViewToggleVisibility,
    stickyViewContainerRef,
    stickyViewToggleRef,
  };

  return <MapListingContext.Provider value={contextValues}>{children}</MapListingContext.Provider>;
};
